import { NavLink, Outlet } from 'react-router-dom'
import { Tags, Banknote } from 'lucide-react'
import { useTranslation } from 'react-i18next'

/**
 * One Kampanjer page, two tabs (#583).
 *
 * The tabs are routes rather than local state so a tab can be linked and
 * bookmarked, and so the old /leasingkampanjer bookmark has somewhere to
 * redirect to. Same underline treatment as OppslagLayout and BruktbilLayout.
 *
 * No shared filter bar: the two grids read different tables with nothing in
 * common to lift. Each tab keeps its own heading, which is why this frame
 * deliberately renders no <h1> of its own.
 */
export default function KampanjerLayout() {
  const { t } = useTranslation('kampanjer')
  const tabs = [
    { label: t('layout.tabs.leasing'), path: 'leasing', icon: Tags },
    { label: t('layout.tabs.laan'), path: 'laan', icon: Banknote },
  ]

  return (
    <div className="space-y-4">
      <div className="flex border-b border-gray-200 dark:border-gray-700 gap-1 overflow-x-auto">
        {tabs.map((tab) => (
          <NavLink
            key={tab.path}
            to={`/kampanjer/${tab.path}`}
            className={({ isActive }) =>
              `px-4 py-2 font-medium border-b-2 transition-colors whitespace-nowrap ${
                isActive
                  ? 'border-primary-600 text-primary-600 dark:border-primary-400 dark:text-primary-400'
                  : 'border-transparent text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
              }`
            }
          >
            <span className="flex items-center gap-2">
              <tab.icon className="w-4 h-4" />
              {tab.label}
            </span>
          </NavLink>
        ))}
      </div>

      <Outlet />
    </div>
  )
}
